import { StatusEnum } from "./pedido";

export class RegistroPedidoIfood {
  orderId: string;
  statusPedido: StatusEnum;
  motivoCancelamento: string;
}
